import { postCouponReceiveAll } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type ReceiveAllCouponsServiceRequest,
  ReceiveAllCouponsServiceRequestSchema,
  type ReceiveAllCouponsServiceResponse,
  ReceiveAllCouponsServiceResponseSchema,
} from './receiveAllCoupons.dto';

const transformApiResponseToServiceResponse = async (
  request: ReceiveAllCouponsServiceRequest,
): Promise<ReceiveAllCouponsServiceResponse> => {
  const response = await postCouponReceiveAll({
    shopTitle: request.shopTitle,
  });

  const successCouponNos = response.data.results
    .filter((result) => result.success)
    .map((result) => result.couponNo);

  const failedResults = response.data.results
    .filter((result) => !result.success)
    .map((result) => ({
      couponNo: result.couponNo,
      errorCode: result.errorCode,
    }));

  return {
    totalCount: response.data.totalCount,
    successCount: response.data.successCount,
    failedCount: response.data.failedCount,
    successCouponNos,
    failedResults,
  };
};

export const receiveAllCouponsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(ReceiveAllCouponsServiceRequestSchema),
    transformApiResponseToServiceResponse,
    validateServiceResponse(ReceiveAllCouponsServiceResponseSchema),
  ),
);
